import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';


import App from './App.vue';

import Home from './view/homeVue.vue';
import Animaux from './view/animauxVue.vue';
import Legal from './view/legalVue.vue';
import Sos from './view/sosVue.vue';
import Ferme from './view/FermeVue.vue';
import Service from './view/serviceVue.vue';
import HelloAsso from './view/helloAsso.vue';
import Adopter from './view/adopteVue.vue';
import Partenaire from './view/partenaireVue.vue';
import Shops from './view/shopVue.vue';
import Besoins from './view/besoinsVue.vue';
import Information from './view/informationVue.vue';
import Actu from './view/actuVue.vue';
import AnimalPage from './view/animauxDetails.vue';
import NewsPage from './view/newsPage.vue';
import Signalement from './view/signalementVue.vue';
import Fourriere from './view/fourriereVue.vue';
import Faq from './view/faqVue.vue';
import Benevole from './view/benevoleVue.vue';
import Cec from './view/cecVue.vue';
import ContentPage from './view/contentPage.vue';
import Tarif from './view/tarifsVue.vue';
import InfoRefuge from './view/infoRefuge.vue';
import Dons from './view/donVue.vue';
const routes = [
    { path: '/redirect', redirect: '/' },
    { path: '/', component: Home },
    { path: '/partenaires', component: Partenaire },
    { path: '/faq', component: Faq },
    { path: '/shops', component: Shops },
    { path: '/hello-asso', component: HelloAsso },
    { path: '/besoins', component: Besoins },
    { path: '/sos', component: Sos },
    { path: '/actualites', component: Actu },
    { path: '/animaux_ferme', component: Ferme },
    { path: '/actions', component: Service },
    { path: '/animaux_trouve', component: Fourriere },
    { path: '/benevolat', component: Benevole },
    { path: '/adopte', component: Adopter },
    { path: '/legal', component: Legal },
    { path: '/info_refuge', component: Information },
    { path: '/animaux', component: Animaux },
    { path: '/signalement', component: Signalement },
    { path: '/dons', component: Dons },
    { path: '/cec', component: Cec },
    { path: '/qui-sommes-nous', component: InfoRefuge },
    { path: '/tarifs', component: Tarif },
    { path: '/publication/:id', component: NewsPage },
    { path: '/animaux/:id', component: AnimalPage },
    { path: '/page/:id', component: ContentPage },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        } else {
            return { top: 0 };
        }
    },
});

// Créer l'application Vue
const app = createApp(App);
app.config.globalProperties.$idSite = 45;


// Utiliser le routeur
app.use(router);

// Monter l'application
app.mount('#app');